import { GET_ALL_DEPARTMENT } from '../../types'

const INITIAL_STATE = {
  getAllDepartment: [],
}

const departmentReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_DEPARTMENT:
      return {
        ...state,
        getAllDepartment: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default departmentReducer
